import { FC } from 'react';

import { AiChatFeedbackDetails } from '../../types';
import { hasFeedbackDetails } from '../../utility/ai-chat-content';
import FeedbackMessage from './FeedbackMessage';
import { AssistantSideRow, FeedbackBubbleContainer } from './styles';

export interface FeedbackBubbleProps {
    feedback: AiChatFeedbackDetails;
    maxWidth: number;
}

const FeedbackBubble: FC<FeedbackBubbleProps> = ({ feedback, maxWidth }) => {
    if (!hasFeedbackDetails(feedback)) {
        return null;
    }

    return (
        <AssistantSideRow>
            <FeedbackBubbleContainer maxWidth={maxWidth}>
                <FeedbackMessage feedback={feedback} />
            </FeedbackBubbleContainer>
        </AssistantSideRow>
    );
};

export default FeedbackBubble;
